module.exports = __webpack_public_path__ + "img/zhaoshang_tuiguang@2x.ad0733c0.png";